// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1ccDt","selects":"Documents_selects__2T802"};